import type { TagColor } from '@/shared/data/tags';

export const defaultTagColor: TagColor = 'neutral';

export const normalizeTagsAndColors = (
  tags: string[],
  colors: TagColor[],
): { tags: string[]; colors: TagColor[] } => {
  const seen = new Set<string>();
  const normalized: Array<{ tag: string; color: TagColor }> = [];

  tags.forEach((tag, index) => {
    const trimmedTag = tag.trim();
    if (trimmedTag.length === 0 || seen.has(trimmedTag)) {
      return;
    }
    seen.add(trimmedTag);
    normalized.push({
      tag: trimmedTag,
      color: colors[index] ?? defaultTagColor,
    });
  });

  return {
    tags: normalized.map((item) => item.tag),
    colors: normalized.map((item) => item.color),
  };
};
